import { requireMediaDevices } from '../utils/browser.js';

export class Screen {
  private stream: MediaStream | null = null;

  async start(options: DisplayMediaStreamOptions = { video: true, audio: false }): Promise<MediaStream> {
    const mediaDevices = requireMediaDevices();
    if (!mediaDevices.getDisplayMedia) throw new Error('Screen sharing is not supported by this browser');

    const stream = await mediaDevices.getDisplayMedia(options);
    this.stop();
    this.stream = stream;
    return stream;
  }

  getStream(): MediaStream | null {
    return this.stream;
  }

  getTrack(): MediaStreamTrack | null {
    return this.stream?.getVideoTracks()[0] ?? null;
  }

  isSharing(): boolean {
    return this.getTrack()?.readyState === 'live';
  }

  stop(): void {
    this.stream?.getTracks().forEach((track) => track.stop());
    this.stream = null;
  }
}
